import { createRoute, Link } from '@tanstack/react-router';
import { z } from 'zod';
import { Route as rootRoute } from './__root';
import { AuthShell } from '../components/AuthShell';

const searchSchema = z.object({ email: z.string().catch('') });

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/check-email',
  validateSearch: searchSchema,
  component: CheckEmailPage,
});

function MessageIcon() {
  return (
    <svg
      width="82"
      height="82"
      viewBox="0 0 82 82"
      fill="none"
      aria-hidden="true"
      className="text-accent"
    >
      <path
        d="M75.1667 18.792H30.75C26.9917 18.792 23.9167 21.867 23.9167 25.6253V56.3753C23.9167 58.1876 24.6366 59.9257 25.9181 61.2072C27.1996 62.4887 28.9377 63.2087 30.75 63.2087H75.1667C78.9592 63.2087 82 60.1678 82 56.3753V25.6253C82 23.813 81.2801 22.0749 79.9986 20.7934C78.7171 19.5119 76.979 18.792 75.1667 18.792ZM75.1667 56.3753H30.75V31.3312L52.9583 42.7087L75.1667 31.3312V56.3753ZM52.9583 36.9345L30.75 25.6253H75.1667L52.9583 36.9345ZM17.0833 56.3753C17.0833 56.9562 17.1858 57.5028 17.2542 58.0837H3.41667C1.53067 58.0837 0 56.5462 0 54.667C0 52.7878 1.53067 51.2503 3.41667 51.2503H17.0833V56.3753ZM10.25 23.917H17.2542C17.1858 24.4978 17.0833 25.0445 17.0833 25.6253V30.7503H10.25C8.37083 30.7503 6.83333 29.2128 6.83333 27.3337C6.83333 25.4545 8.37083 23.917 10.25 23.917ZM3.41667 41.0003C3.41667 39.1212 4.95417 37.5837 6.83333 37.5837H17.0833V44.417H6.83333C4.95417 44.417 3.41667 42.8795 3.41667 41.0003Z"
        fill="currentColor"
      />
    </svg>
  );
}

function CheckEmailPage() {
  const { email } = Route.useSearch();

  return (
    <AuthShell>
      <div className="flex justify-center">
        <MessageIcon />
      </div>

      <h1 className="text-primary mt-6 text-center text-2xl font-semibold">
        Check your email
      </h1>
      <p className="text-muted mx-auto mt-2 max-w-xs text-center text-sm">
        We emailed a magic link to{' '}
        <span className="text-primary font-medium">
          {email || 'your inbox'}
        </span>
        . Click the link in your email to sign in directly.
      </p>

      <div className="mt-8 flex justify-center">
        <Link
          to="/login"
          className="text-muted hover:text-primary inline-flex items-center gap-2 text-xs transition-colors"
        >
          <svg
            width="14"
            height="10"
            viewBox="0 0 14 10"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M13 5H1M1 5L5 1M1 5L5 9"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Back to log in
        </Link>
      </div>
    </AuthShell>
  );
}
